module.exports = __webpack_public_path__ + "static/media/morning-snack.6a75cb85.png";